import React, { useRef, useState, useEffect, memo } from "react";

const placeholderImg = "/images/loading.gif";

const LazyImage = memo(({ src, alt, placeholderSrc = placeholderImg }) => {
  const [imageSrc, setImageSrc] = useState(placeholderSrc);
  const [error, setError] = useState(null);
  const imageRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          const img = new Image();
          img.src = src;
          img.onload = () => setImageSrc(src);
          img.onerror = () => setError("Failed to load image");
        }
      },
      { threshold: 0.5 } // 0.5 means 50% of the image must be visible to trigger the callback
    );

    const imgRef = imageRef.current;

    if (imgRef) {
      observer.observe(imgRef);
    }

    return () => {
      if (imgRef) {
        observer.unobserve(imgRef);
      }
    };
  }, [src]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <img
      ref={imageRef}
      src={imageSrc}
      alt={alt}
      style={{
        width: "100%",
        height: "auto",
        opacity: isVisible ? 1 : 0.5,
        transition: "opacity 0.3s ease-in-out",
      }}
    />
  );
});

export default LazyImage;
